export default "__VITE_ASSET__WKGskUBG__"